import type { Discount } from "@apps/gwservice/types"
import { DiscountCard } from "./discount-card"

interface Props {
  discounts: Discount[]
}

export function DiscountsFeed({ discounts }: Props) {
  return (
    <div className="flex flex-col gap-s p-m">
      {discounts.map((discount) => (
        <DiscountCard key={discount.id} discount={discount} />
      ))}
    </div>
  )
}
